@if (text()) {
  <mat-icon class="light help-icon"
            [matTooltip]="text()!"
            [matTooltipClass]="{ 'uzai-tooltip': true }"
            [matTooltipPosition]="position()">{{ icon() }}
  </mat-icon>
}
